/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
var ContainerBase = Backbone.View.extend({
  events: {
    'scroll': 'onScroll',
    'resize': 'onResize'
  },
  onScroll: function (e) {
    this.trigger('scroll:container', e);
  },
  onResize: function (e) {
    this.trigger('resize:container', e);
  },
  offset: function (element, scrollTop, scrollLeft) {
    throw new Error('Offset function not implemented');
  }
});
export default ContainerBase;

